import PropTypes from "prop-types";
import { Skeleton } from "@figeleton/skeleton";

function StyledSkeleton({
  animation = "pulse",
  startColor = "rgba(227, 227, 227, 1)",
  endColor = "rgba(222, 222, 222, 1)",
  style,
  ...props
}) {
  return (
    <Skeleton
      animation={animation}
      startColor={startColor}
      endColor={endColor}
      style={{
        position: "absolute",
        // width: "100%",
        ...style,
      }}
      {...props}
    />
  );
}

StyledSkeleton.propTypes = {
  animation: PropTypes.string,
  endColor: PropTypes.string,
  startColor: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

StyledSkeleton.defaultProps = {
  animation: "pulse",
  startColor: "rgba(227, 227, 227, 1)",
  endColor: "rgba(222, 222, 222, 1)",
};

export { StyledSkeleton };
